import {config} from "../config";

export function sendUrlParams(uniqId: string, userId: any): void {
    try {
        const search = window.location.search;

        if (!search || search.length <= 1) {
            return;
        }

        const params = new URLSearchParams(search);
        const query: Record<string, string | string[]> = {};

        // @ts-ignore
        for (const [key, value] of params.entries()) {
            if (query[key] !== undefined) {
                const existingValue = query[key];

                if (Array.isArray(existingValue)) {
                    existingValue.push(value);
                } else {
                    query[key] = [existingValue, value];
                }
            } else {
                query[key] = value;
            }
        }

        if (Object.keys(query).length === 0) {
            return;
        }

        const payload = {
            query,
            'uniqId' : uniqId,
             'userId' : userId
        };

        fetch(config.serverUrl+ '/api/analytics/store', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({data:payload}),
        }).catch((error) => {
            console.error('Failed to send URL params:', error);
        });
    } catch (error) {
        console.error('Failed to prepare URL params:', error);
    }
}